import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/ui/stepper";
import { useTranslation } from "@/hooks/useTranslation";
import { FiChevronRight } from "react-icons/fi";

export const SetupTeamCreationWelcomePage = () => {
  const { nextStep } = useStepper();
  const { t } = useTranslation();

  return (
    <div className="space-y-5 text-center">
      <h1 className="text-2xl font-bold text-primary">
        {t("setup.teamCreation.welcome.title")}
      </h1>
      <p className="text-md">{t("setup.teamCreation.welcome.description")}</p>
      <Button onClick={nextStep}>
        {t("setup.teamCreation.welcome.button")}
        <FiChevronRight className="w-4 h-4 ml-2" />
      </Button>
    </div>
  );
};
